// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1-MZg","content":"LoadingAlert_content__uugWI"};